import React from 'react';

export const SecondaryEditIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M2904,333v-1h0.14l0.59-2.654,2.62,2.654H2918v1h-14Zm12.26-9.571-2.84-2.869,1.22-1.226a1.24,1.24,0,0,1,1.77,0l1.27,1.28a0.984,0.984,0,0,1,0,1.385Zm-7.93,8.009-2.84-2.869,7.19-7.263,2.84,2.869Z"
      transform="translate(-2904 -318.969)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/secondary-edit-icon.js